import { type TerminologyAttributes } from './generated/TerminologyAttributes';
import ApplicationModel, { attr } from '../ApplicationModel';
import { model } from '../modelBuilder';

interface Terminology extends TerminologyAttributes {}

@model
class Terminology extends ApplicationModel {
  // Start auto-generated
  static typename: 'Terminology' = 'Terminology';
  get typename(): 'Terminology' {
    return 'Terminology';
  }

  static fields = {
    epic: attr.belongsTo({ readable: true, typename: 'TerminologyItem' }),
    epoch: attr.belongsTo({ readable: true, typename: 'TerminologyItem' }),
    feature: attr.belongsTo({ readable: true, typename: 'TerminologyItem' }),
    goal: attr.belongsTo({ readable: true, typename: 'TerminologyItem' }),
    idea: attr.belongsTo({ readable: true, typename: 'TerminologyItem' }),
    ideaEndorsement: attr.belongsTo({
      readable: true,
      typename: 'TerminologyItem',
    }),
    ideaOrganization: attr.belongsTo({
      readable: true,
      typename: 'TerminologyItem',
    }),
    initiative: attr.belongsTo({ readable: true, typename: 'TerminologyItem' }),
    iteration: attr.belongsTo({ readable: true, typename: 'TerminologyItem' }),
    masterRelease: attr.belongsTo({
      readable: true,
      typename: 'TerminologyItem',
    }),
    product: attr.belongsTo({ readable: true, typename: 'TerminologyItem' }),
    productLine: attr.belongsTo({
      readable: true,
      typename: 'TerminologyItem',
    }),
    productOwner: attr.belongsTo({
      readable: true,
      typename: 'TerminologyItem',
    }),
    programIncrement: attr.belongsTo({
      readable: true,
      typename: 'TerminologyItem',
    }),
    release: attr.belongsTo({ readable: true, typename: 'TerminologyItem' }),
    releaseDate: attr.belongsTo({
      readable: true,
      typename: 'TerminologyItem',
    }),
    releaseMilestone: attr.belongsTo({
      readable: true,
      typename: 'TerminologyItem',
    }),
    releasePhase: attr.belongsTo({
      readable: true,
      typename: 'TerminologyItem',
    }),
    requirement: attr.belongsTo({
      readable: true,
      typename: 'TerminologyItem',
    }),
    subRelease: attr.belongsTo({ readable: true, typename: 'TerminologyItem' }),
    task: attr.belongsTo({ readable: true, typename: 'TerminologyItem' }),
  };
  // End auto-generated
}

export default Terminology;
